import React, { useEffect, useState, FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import {handleDownloadClick, handleDownloadClickAsZip} from '@utils/material.utils';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import {
    Attachment,
    AttachmentIcon,
    AttachmentName,
    ButtonDownload,
    Content,
    InfoMessage,
    Title,
    TitleSymbol,
    Wrapper,
} from './ConferenceAttachments.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceAttachmentsTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    const [attachments, setAttachments] = useState([]);
    const [termAccessible, setTermAccessible] = useState(false);

    useEffect(() => {
        if (conf) {
            for (let x = 0; x < conf?.dates.length; x++) {
                for (let z = 0; z < conf?.dates[x].attachments.length; z++) {
                    attachments.push(conf?.dates[x]?.attachments[z]);
                }
            }
            const attachmentsUnique = attachments.filter(
                (value, index, self) => self.map((x) => x._key).indexOf(value._key) == index
            );
            setAttachments(attachmentsUnique);

            for (const date of conf?.dates) {
                if (date.accessible) {
                    setTermAccessible(true);
                    break;
                }
            }
        }
    }, [conf]);

    const orderedAttachments = attachments.sort((a, b) => a.order - b.order);

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.ATTACHMENTS}`}>
            <Title colors={colors}>
                {t('conference.component.attachments.title')}
                <TitleSymbol colors={colors} />
            </Title>

            {attachments.length > 0 ? (
                <>
                    {orderedAttachments?.map((item, index) => (
                        <Content key={index}>
                            <Attachment
                                key={`attachmentKey${index}`}
                                onClick={() => handleDownloadClick(item._key, item.filename, false, item.mime_type)}
                            >
                                <AttachmentIcon name={Icons.File} />
                                <AttachmentName colors={colors}>{item.name}</AttachmentName>
                            </Attachment>
                        </Content>
                    ))}

                    <ButtonDownload
                        colors={colors}
                        onClick={() => handleDownloadClickAsZip(attachments, conf?.conference?.slug)}
                    >
                        {t('conference.attachments.download.all')}
                    </ButtonDownload>
                </>
            ) : (
                <Content>
                    {termAccessible && attachments.length === 0 && (
                        <InfoMessage>{t('conference.attachments.emptyResult.accessible')}</InfoMessage>
                    )}
                    {!termAccessible && attachments.length === 0 && (
                        <InfoMessage>{t('conference.attachments.emptyResult')}</InfoMessage>
                    )}
                </Content>
            )}
        </Wrapper>
    );
};

export default ConferenceAttachmentsTemplate;
